import theme from '@styles/theme';
export default {
  section: {
    textAlign: 'center',
    display: 'flex',
    padding: ['0 12px 50px', '0 12px 40px', '0 12px 150px', '0 12px 200px', '0 12px']
  },
  container: {
    mt: ['-61px', '-61px', '-61px', '-61px', '-9vw'],
    zIndex: theme.zIndex.documentUp
  },
  laptopVideo: {
    position: 'relative',
    height: ['185.75px', '185.75px', '372px', '372px', '34vw'],
    maxHeight: '41em',
    m: '0 auto'
  },
  playerIcon: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    opacity: '0.8',
    zIndex: theme.zIndex.documentUp,
    '&:hover': {
      opacity: 1
    },
    ':after': {
      content: '""',
      borderStyle: 'solid',
      borderWidth: '15px 0 15px 25px',
      borderColor: 'transparent transparent transparent #000000',
      position: 'absolute',
      top: 'calc(50% + 1px)',
      left: 'calc(50% + 3px)',
      transform: 'translate(-50%, -50%) rotate(-1deg)',
      zIndex: '0'
    }
  },
  tryVoxbox: {
    m: ['50px 0', '50px 0', '90px 0'],
    p: {
      margin: ['0 auto 10px', '0 auto 10px', '0 auto 10px', '0 auto 10px', '0 auto 40px'],
      width: ['auto', 'auto', '440px'],
      fontSize: 16
    }
  },
  buttonBox: {
    padding: [0, 0, 0, 0, '20px 0'],
    position: 'relative',
    width: ['auto', 'auto', 'auto', 'auto', 'fit-content'],
    m: '0 auto',
    color: theme.rawColors.neutralBlack,
    button: {
      width: ['auto', 'auto', 'auto', 'auto', '280px']
    },
    '.openModal': {
      position: ['static', 'static', 'static', 'static', 'absolute'],
      display: ['block', 'block', 'block', 'block', 'inline'],
      right: '0',
      width: ['auto', 'auto', 'auto', 'auto', '280px'],
      bottom: '-8px',
      fontSize: '12px',
      color: theme.rawColors.darkGrey700,
      textDecoration: 'underline',
      pb: [40, 40, 40, 40, 0]
    }
  },
  orEl: {
    m: '0 12px'
  }
};